/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Topic900Img from '../../../../../../assets/2025/topic900/elePerson1-1.png';
import { useStore } from '../../../../store';
import VideoTranscript from '../../components/videoTranscript';

interface ISection1Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video900');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video900')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video900')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video900')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document?.querySelector('#video900')?.removeEventListener('play', onPlay);
  }, []);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <div className="">
            <div className="title">
              <i className="title_icon" />
              <div className="text_item">
                <span>{paragraphsSettings?.message}</span>
                <span>{paragraphsSettings?.message1}</span>
              </div>
            </div>
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.description,
              }}
            />
          </div>
          <div className="video_box">
            <div className="landing-img">
              <img src={Topic900Img} alt="" />
              <i className="icon_clock" />
              <i className="icon_flower" />
            </div>
            <div className="video-container">
              <video
                id="video900"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
          </div>
        </div>
      </div>
      <i className="back_line" />
    </div>
  );
};

export default Section0;
